import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import { StyledButton } from "components/Button/StyledButton"
import { Status } from "graphql/types"
import { useState } from "react"
import { getTextForStatus } from "utils/status"

type StatusSelectProps = {
  value: Status
  // eslint-disable-next-line no-unused-vars
  onChange: (value: Status) => void
}

export const StatusSelect = (props: StatusSelectProps) => {
  const { value, onChange } = props

  const [status, setStatus] = useState<Status>(value)

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <FormControl fullWidth>
        <InputLabel>Status</InputLabel>
        <Select
          size="small"
          value={status}
          onChange={(e) => setStatus(e.target.value as Status)}
          label="Status"
        >
          {Object.values(Status).map((item) => (
            <MenuItem key={item} value={item}>
              {getTextForStatus(item)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
        <StyledButton buttonType="cancel" onClick={() => setStatus(value)}>
          Abbrechen
        </StyledButton>
        <StyledButton buttonType="save" onClick={() => onChange(status)}>
          Speichern
        </StyledButton>
      </Box>
    </Box>
  )
}
